import { Capacitor } from '@capacitor/core';
import XsPreferencesDrawerToolbar from '@/components/table/XsPreferencesDrawerToolbar';
import type { AccountsExportToolbarConfig } from './accountsExport';
import { AccountsExportMenuButton } from './accountsExportMenuButton';
import { AccountsGridToolbar } from './accountsGridToolbar';

interface AccountsGridToolbarSlotProps {
  accountsExportConfig?: AccountsExportToolbarConfig;
}

function requireExportConfig(
  config: AccountsExportToolbarConfig | undefined,
): AccountsExportToolbarConfig {
  if (!config) {
    throw new Error('Accounts export toolbar configuration is required.');
  }
  return config;
}

export function AccountsDesktopGridToolbar({
  accountsExportConfig,
}: AccountsGridToolbarSlotProps) {
  return (
    <AccountsGridToolbar
      exportConfig={requireExportConfig(accountsExportConfig)}
    />
  );
}

export function AccountsNativeGridToolbar({
  accountsExportConfig,
}: AccountsGridToolbarSlotProps) {
  return (
    <AccountsGridToolbar
      exportConfig={requireExportConfig(accountsExportConfig)}
      touchFriendly
    />
  );
}

export function AccountsXsGridToolbar({
  accountsExportConfig,
}: AccountsGridToolbarSlotProps) {
  const exportConfig = requireExportConfig(accountsExportConfig);
  const touchFriendly = Capacitor.getPlatform() !== 'web';

  return (
    <XsPreferencesDrawerToolbar
      showQuickFilter
      touchFriendly={touchFriendly}
      exportControl={
        <AccountsExportMenuButton
          config={exportConfig}
          touchFriendly={touchFriendly}
        />
      }
    />
  );
}
